/**
 * /frontend/src/features/analytics/components/charts/DistributionPieChart.js
 */

import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { CHART_CONFIG } from '../../constants/chartConfig';
import { PIE_COLORS } from '../../constants/chartColors';

/**
 * Generic pie chart for distributions.
 * @param {{data:any[],nameKey:string,valueKey:string,height?:number,colors?:string[]}} props
 * @returns {JSX.Element}
 */
const DistributionPieChart = ({ data, nameKey, valueKey, height, colors }) => {
  const safeData = Array.isArray(data) ? data : [];
  if (!safeData.length) {
    return <div className="analytics-chart-empty-inline">No data available for the selected range.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={height || CHART_CONFIG.height}>
      <PieChart>
        <Tooltip />
        <Pie data={safeData} dataKey={valueKey} nameKey={nameKey} innerRadius={60} outerRadius={110} paddingAngle={2}>
          {safeData.map((entry, index) => (
            <Cell key={`${entry?.[nameKey] || index}`} fill={(colors || PIE_COLORS)[index % (colors || PIE_COLORS).length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default DistributionPieChart;
